import { AuthenticationResult } from '@azure/msal-browser';
import { DataStore, DataStoreKeys } from '../data-store';
import { DebugOptions } from '../../types';

interface TokenStore {
    idToken: string
}




export class UserCache {


    public static set idToken(token: string) {
        let data: TokenStore = {
            idToken: token
        }
        DataStore.setData(DataStoreKeys.ID_TOKEN, data);
    }

    public static get idToken(): string {
        let tokenInfo = DataStore.getData(DataStoreKeys.ID_TOKEN) as TokenStore;
        if (tokenInfo) {
            return tokenInfo.idToken;
        }
        return "";
    }

    public static get sessionId(): string {
        let sessionInfo = DataStore.getData(DataStoreKeys.SESSION_ID) as string;
        if (sessionInfo) {
            return sessionInfo;
        }
        return "";
    }

    public static set sessionId(sessionId: string) {
        DataStore.setData(DataStoreKeys.SESSION_ID, sessionId);
    }


    public static get authenticationResult(): AuthenticationResult {
        return DataStore.getData(DataStoreKeys.AUTHENTICATION_RESULT) as AuthenticationResult;

    }

    public static set authenticationResult(value: AuthenticationResult) {

        DataStore.setData(DataStoreKeys.AUTHENTICATION_RESULT, value);
    }

    public static clear(): void {
        DataStore.removeData(DataStoreKeys.ID_TOKEN);
        DataStore.removeData(DataStoreKeys.AUTHENTICATION_RESULT);
    }

    public static get debugOptions(): DebugOptions {
        return DataStore.getData(DataStoreKeys.DEBUG_OPTIONS) as DebugOptions;
    }


    public static set debugOptions(value: DebugOptions) {
        DataStore.setData(DataStoreKeys.DEBUG_OPTIONS, value);
    }

    public static get oryState(): any {
        return DataStore.getData(DataStoreKeys.ORY_STATE) as DebugOptions;
    }


    public static set oryState(value: any) {
        DataStore.setData(DataStoreKeys.ORY_STATE, value);
    }


}